import translations from './translations'

translations.add('es', {
    payNewCard: 'Pagar con una tarjeta nueva'
})
